import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0928a4ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-c-hub-endpoint pfizer-light-diagonal-background" }
const _hoisted_2 = { class: "hd-c-hub-endpoint__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_covid_endpoint_header = _resolveComponent("covid-endpoint-header")!
  const _component_covid_endpoint_section_navigation = _resolveComponent("covid-endpoint-section-navigation")!
  const _component_versions_dynamic_view = _resolveComponent("versions-dynamic-view")!
  const _component_loader_default = _resolveComponent("loader-default")!
  const _component_covid_endpoint_content = _resolveComponent("covid-endpoint-content")!
  const _component_covid_section_pages = _resolveComponent("covid-section-pages")!
  const _component_covid_endpoint_navigation = _resolveComponent("covid-endpoint-navigation")!
  const _component_citations_module = _resolveComponent("citations-module")!
  const _component_covid_endpoint_footer = _resolveComponent("covid-endpoint-footer")!
  const _component_layout_endpoint = _resolveComponent("layout-endpoint")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_layout_endpoint, null, {
      header: _withCtx(() => [
        _createVNode(_component_covid_endpoint_header),
        _createVNode(_component_versions_dynamic_view, null, {
          galaxy: _withCtx(() => [
            _createVNode(_component_covid_endpoint_section_navigation)
          ]),
          _: 1
        })
      ]),
      navigation: _withCtx(() => [
        _createVNode(_component_versions_dynamic_view, null, {
          galaxy: _withCtx(() => [
            _createVNode(_component_covid_section_pages)
          ]),
          _: 1
        }),
        _createVNode(_component_covid_endpoint_navigation)
      ]),
      citations: _withCtx(() => [
        (_ctx.endpointData.citations)
          ? (_openBlock(), _createBlock(_component_citations_module, {
              key: 0,
              citations: _ctx.endpointData.citations
            }, null, 8, ["citations"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_covid_endpoint_footer)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.hasEndpointData)
            ? (_openBlock(), _createBlock(_component_loader_default, { key: 0 }))
            : (_openBlock(), _createBlock(_component_covid_endpoint_content, { key: 1 }))
        ])
      ]),
      _: 1
    })
  ]))
}